export default __webpack_public_path__ + "static/media/sai.887727fb.jpg";